module.exports = __webpack_public_path__ + "static/img/light.487632b8.svg";